module.exports = __webpack_public_path__ + "static/media/toBottom.b4bad6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/toBottom.png
// module id = 1862
// module chunks = 0 1